import { render, staticRenderFns } from "./not-selected.vue?vue&type=template&id=1ed4ce8c&scoped=true&"
import script from "./not-selected.vue?vue&type=script&lang=js&"
export * from "./not-selected.vue?vue&type=script&lang=js&"
import style0 from "./not-selected.vue?vue&type=style&index=0&id=1ed4ce8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed4ce8c",
  null
  
)

export default component.exports